import {createSlice} from "@reduxjs/toolkit";
import {setInsightsDisposalCostType, setInsightsFilter, setInsightsHaulMethod, setInsightsRateModel} from "./actions";
import {startOfDay, subDays} from "@ots-frontend/ots-data"
import {InsightsDisposalCostType} from "./model/insights-disposal-cost-type";

type InsightsState = {
  filter: {
    fromDttm: number,
    toDttm?: number
  },
  haulMethod?: string
  disposalCostType: InsightsDisposalCostType
  rateModel?: string
}

const INITIAL_STATE: Readonly<InsightsState> = {
  filter: {
    fromDttm: subDays(startOfDay(new Date()), 1).getTime(),
  },
  haulMethod: undefined,
  disposalCostType: "excludeDisposalCosts",
  rateModel: undefined,
};

const insightsSlice = createSlice({
  name: "ui/insights",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setInsightsFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setInsightsHaulMethod,
      (state, {payload}) => {
        state.haulMethod = payload?.code
      }
    );
    builder.addCase(
      setInsightsDisposalCostType,
      (state, {payload}) => {
        state.disposalCostType = payload
      }
    );
    builder.addCase(
      setInsightsRateModel,
      (state, {payload}) => {
        state.rateModel = payload
      }
    );
  }
});

export const insightsReducer = insightsSlice.reducer;
